function ArticleDetailsLoader() {
  return (
    <div className="flex w-full gap-5 max-lg:flex-col">
      <div className="bg-body-text animate-pulse rounded-lg lg:w-[400px] xl:w-[500px]" />
      <div className="w-full">
        <div className="bg-body-text mb-3 h-5 w-1/3 animate-pulse rounded-md" />
        <div className="bg-body-text mb-3 h-5 w-full animate-pulse rounded-md" />
        <div className="bg-body-text mb-3 h-5 w-4/5 animate-pulse rounded-md" />
        <div className="bg-body-text mb-3 h-5 w-3/5 animate-pulse rounded-md" />
        <div className="bg-body-text mb-3 h-5 w-2/5 animate-pulse rounded-md" />
        <div className="bg-body-text mb-3 h-5 w-4/5 animate-pulse rounded-md" />
        <div className="bg-body-text mb-3 h-5 w-3/5 animate-pulse rounded-md" />
      </div>
    </div>
  );
}

export default ArticleDetailsLoader;
